import React, { useState, useEffect } from 'react'
// import { Autocomplete, useLoadScript } from "@react-google-maps/api";
// const placesLibrary = ["places"];
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { getCityList } from '../../../redux/slices/activity'
import { useSelector } from 'react-redux'
import { dispatch } from '../../../redux/store'
import { Box } from '@mui/material'

const CarDropLocation = ({ setCityDropValue, cityDropValue, cityQuery }) => {
  const { cityListRes } = useSelector(state => state.activity)
  const [cityList, setCityList] = useState([])
  const handleAutocompleteChange = (event, value) => {
    setCityDropValue(value)
    //
  }

  useEffect(() => {
    dispatch(getCityList({ search: '' }))
  }, [dispatch])

  useEffect(() => {
    if (cityListRes) {
      setCityList(cityListRes.responseData)
    }
  }, [cityListRes])

  return (
    <>
      <Box className={`searchMenu-loc lg:px-0 js-form-dd`}
        sx={{
          '& label.Mui-focused': {
            color: 'black'
          },
          '& .MuiInputBase-input': {
            // height: "16px",
          },
          '& .MuiAutocomplete-clearIndicator': {
            display: 'none' // Hides the clear (close) button
          },

          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: '1px solid rgba(0, 0, 0, 0.5)'
          },
          '& .MuiInput-underline:after': {
            border: '1px solid rgba(0, 0, 0, 0.5)'
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: '1px solid rgba(0, 0, 0, 0.5)',
              borderRadius: '8px'
            },
            '&:hover fieldset': {
              border: '1px solid rgba(0, 0, 0, 0.5)'
            },
            '&.Mui-focused fieldset': {
              border: '1px solid rgba(0, 0, 0, 0.5)'
            }
          }
        }}>
        {/* <label>Destination</label> */}
        <Autocomplete
          size='small'
          disablePortal
          id='combo-box-demo'
          value={cityDropValue}
          options={cityList.map(data => data.cityName)}
          onChange={handleAutocompleteChange}
          renderInput={params => (
            <TextField {...params} placeholder='Drop Location' />
          )}
        />
      </Box>
    </>
  )
}

export default CarDropLocation
